import { render, staticRenderFns } from "./complainDialog.vue?vue&type=template&id=9e5b7dae&scoped=true"
import script from "./complainDialog.vue?vue&type=script&lang=js"
export * from "./complainDialog.vue?vue&type=script&lang=js"
import style0 from "./complainDialog.vue?vue&type=style&index=0&id=9e5b7dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5b7dae",
  null
  
)

export default component.exports